import { FiltersProps } from "@/core/libs/list-data/lib/filters/interfaces";

/**
 * Coleta todas as entradas de `filterQuery` dos filtros que atendem à condição informada em `shouldInclude`.
 *
 * REGRAS:
 * - Se `filters` estiver vazio ou não for passado, retorna [].
 * - Cada filtro pode ter `filterQuery` como string única ou array de strings; ambas são normalizadas.
 * - Só adiciona as queries dos filtros que sua função `shouldInclude` retornar `true`.
 *
 * Exemplos:
 * const filters: FiltersProps[] = [
 *   { type: ListDataFiltersTypeEnum.SELECT, filterQuery: "status" },
 *   { type: ListDataFiltersTypeEnum.DATE_RANGE, filterQuery: ["startDate", "endDate"] },
 *   { type: ListDataFiltersTypeEnum.TEXT, filterQuery: "searchTerm" }
 * ];
 *
 * // Apenas os filtros de intervalo de data:
 * const dateQueries = extractFilterQueries(filters, filter => filter.type === ListDataFiltersTypeEnum.DATE_RANGE);
 * // Resultado: ["startDate", "endDate"]
 *
 * // Todos que NÃO são intervalo de data:
 * const nonDateQueries = extractFilterQueries(filters, filter => filter.type !== ListDataFiltersTypeEnum.DATE_RANGE);
 * // Resultado: ["status", "searchTerm"]
 *
 * @param filters Lista de filtros (pode ser vazia). Cada item deve ter a propriedade `filterQuery`.
 * @param shouldInclude Função que recebe um filtro e retorna true se ele deve ser considerado.
 * @returns Um array plano de strings com todas as chaves (queries) dos filtros aceitos.
 */
export function extractFilterQueries(
  filters: FiltersProps[],
  shouldInclude: (filter: FiltersProps) => boolean
): string[] {
  if (!filters || filters.length === 0) return [];

  const result: string[] = [];

  for (const filter of filters) {
    if (!shouldInclude(filter)) continue;

    const filterQueries = filter.filterQuery;

    if (Array.isArray(filterQueries)) {
      for (const query of filterQueries) {
        result.push(query);
      }
    } else {
      result.push(filterQueries);
    }
  }

  return result;
}
